module.exports = __webpack_public_path__ + "static/toggl-track-integrations copy-d06c6b98470729e32f3a64b7427c229e.jpg";